import { fetchAllRows } from "./fetchAllRows.js";
import { searchAvailableBusesFromData } from "./busAvailabilityCore.js";

export async function searchAvailableBusesWithClient(client, options) {
  const { date, startTime, passengers, companyId } = options;
  if (!date) throw new Error("date is required");
  if (!startTime) throw new Error("startTime is required");
  if (!Number.isInteger(Number(passengers)) || Number(passengers) <= 0) {
    throw new Error("passengers must be a positive integer");
  }
  const scoped = (query) => companyId ? query.eq("company", companyId) : query;
  const [cars, reservations] = await Promise.all([
    fetchAllRows(() => scoped(client.from("cars")
      .select("car_number, car_number_only, car_name, driver, phone, year, seat, seat_detail, direct, company")
      .order("id"))),
    fetchAllRows(() => scoped(client.from("reservations")
      .select("date, time, arrival_time, car_number, human_name, phone, seat, seat_detail, company")
      .eq("date", date).order("id"))),
  ]);
  return searchAvailableBusesFromData({ ...options, cars, reservations });
}
